import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { mapBadge } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function Feedback() {
  const { L } = useApp();
  const fbOutcomes = [
    { rfq: 'RFQ-2026-005', title: 'Maintenance Services', outcome: 'Awarded', given: false },
    { rfq: 'RFQ-2026-002', title: 'Spare Parts Q2', outcome: 'Not Selected', given: true },
  ].map((o, i) => ({
    ...o,
    selBg: i === 0 ? 'var(--color-blue-100)' : 'var(--color-white)',
    selBorder: i === 0 ? 'var(--color-blue)' : 'var(--color-border)',
    ...mapBadge(o.outcome === 'Awarded' ? 'Awarded' : 'Closed'),
    outcomeText: L(o.outcome, o.outcome === 'Awarded' ? 'มอบสัญญาแล้ว' : 'ไม่ได้รับเลือก'),
    givenText: o.given ? L('Feedback given', 'ให้ความคิดเห็นแล้ว') : L('Pending', 'รอดำเนินการ'),
  }));
  const fbStars = [1, 2, 3, 4, 5].map((n) => ({ n, color: n <= 4 ? 'var(--color-warning)' : 'var(--color-ink-100)' }));

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '320px 1fr', gap: 16, alignItems: 'start' }}>
      <div style={cardPad(16)}>
        <div style={{ fontWeight: 700, marginBottom: 12 }}>{L('RFQ Outcomes', 'ผลลัพธ์ RFQ')}</div>
        {fbOutcomes.map((o) => (
          <div key={o.rfq} style={{ border: `1px solid ${o.selBorder}`, background: o.selBg, borderRadius: 'var(--radius-sm)', padding: 12, marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
              <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: 12 }}>{o.rfq}</span>
              <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: o.stBg, color: o.stFg }}>{o.outcomeText}</span>
            </div>
            <div style={{ fontSize: 13 }}>{o.title}</div>
            <div style={{ fontSize: 11, color: 'var(--color-fg-3)', marginTop: 2 }}>{o.givenText}</div>
          </div>
        ))}
      </div>
      <div style={cardPad(22)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', background: 'var(--color-success-bg)', borderRadius: 'var(--radius-sm)', marginBottom: 18, fontSize: 13, color: 'var(--color-success)' }}>
          <Icon name="award" />
          <span style={{ color: 'var(--color-fg-1)' }}><b>{L('Awarded', 'มอบสัญญาแล้ว')}</b> — Maintenance Services (RFQ-2026-005). {L('Congratulations on winning this contract.', 'ขอแสดงความยินดีที่ได้รับสัญญานี้')}</span>
        </div>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 10 }}>{L('Rate your procurement experience', 'ให้คะแนนประสบการณ์การจัดซื้อของคุณ')}</div>
        <div style={{ display: 'flex', gap: 6, marginBottom: 18 }}>
          {fbStars.map((s) => (
            <Icon key={s.n} name="star" style={{ fontSize: 28, color: s.color }} />
          ))}
        </div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 6 }}>{L('Comments', 'ความคิดเห็น')}</label>
        <textarea placeholder={L('Share your feedback (minimum 20 characters)…', 'แบ่งปันความคิดเห็นของคุณ (อย่างน้อย 20 ตัวอักษร)…')} style={{ width: '100%', minHeight: 100, padding: 11, border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', resize: 'vertical', marginBottom: 16 }} />
        <button className="hv-primary" style={{ padding: '11px 20px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14 }}>{L('Submit Feedback', 'ส่งความคิดเห็น')}</button>
      </div>
    </div>
  );
}
